<template>
  <div>
    Need a hand with anything?
    <div class="text-azure-100">
      <a href="mailto:hello@beam.org" target="blank">We're here to help</a>
    </div>
  </div>
</template>
